import { z } from 'zod';

import type { PatchAdminV1OrgStoresIdBody, Store } from '@nucleus-commerce/api-client/admin';

const wholeIn = (min: number, max: number, message: string) =>
  z
    .string()
    .trim()
    .refine((v) => /^\d+$/.test(v) && Number(v) >= min && Number(v) <= max, { error: message });

/** `settings.returns`, saved through the store PATCH which merges the group. */
export const returnsSettingsSchema = z.object({
  windowDays: wholeIn(0, 365, 'returns:validation.windowDays'),
  allowedByDefault: z.boolean(),
  restockingFeePercent: wholeIn(0, 100, 'returns:validation.feePercent'),
  returnShippingPaidBy: z.enum(['customer', 'store']),
});

export type ReturnsSettingsForm = z.infer<typeof returnsSettingsSchema>;

export function fromReturnsSettings(store: Pick<Store, 'settings'>): ReturnsSettingsForm {
  const { returns } = store.settings;
  return {
    windowDays: String(returns.windowDays),
    allowedByDefault: returns.allowedByDefault,
    restockingFeePercent: String(returns.restockingFeePercent),
    returnShippingPaidBy: returns.returnShippingPaidBy,
  };
}

export function toReturnsSettingsPatch(values: ReturnsSettingsForm): PatchAdminV1OrgStoresIdBody {
  return {
    settings: {
      returns: {
        windowDays: Number(values.windowDays),
        allowedByDefault: values.allowedByDefault,
        restockingFeePercent: Number(values.restockingFeePercent),
        returnShippingPaidBy: values.returnShippingPaidBy,
      },
    },
  };
}
